import type {VehicleResponseType} from "../../Vehicles/types";
import {Assignment} from "../Assignment";
import type {ScenarioResponseType} from "../ScenarioTypes";

export interface IPlanningContext {
    vehicles: VehicleResponseType[];
    assignments: Assignment[];
    scenario: ScenarioResponseType
}


export class PlanningContext {

    private readonly vehicles: VehicleResponseType[];
    private readonly assignments: Assignment[];
    private readonly scenario: ScenarioResponseType;

    constructor(vehicle: VehicleResponseType[], assignments: Assignment[], scenario: ScenarioResponseType) {
        this.vehicles = vehicle;
        this.assignments = assignments;
        this.scenario = scenario;
    }

    public getContext(): IPlanningContext {
        return {
            vehicles: this.vehicles,
            assignments: this.assignments,
            scenario: this.scenario
        };
    }

}